import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostService } from './host.service';


@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private getHost: HostService,
              private http: HttpClient) { }

    public invoiceRenting(id: number, key: string) {
      
      return this.http.get(this.getHost.gethttps()+ 'invoice/'+id+'/'+key, {
        responseType: 'arraybuffer',
        headers: new HttpHeaders().append('Content-Type', 'application/pdf')
      })

    }
}
